import { convertToMarkdown } from "lib/convert-resume-to-md";
import axiosOpenClient from "./axiosOpenClient";

export const parseResumeUsingAi = async (rawPdfData: string) => {
  try {
    const md = convertToMarkdown(rawPdfData)
    // console.log(rawPdfData)
    const response = await axiosOpenClient.post(
      "/public/api/resumes/parse",
      rawPdfData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
